import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getUsers } from 'app/modules/administration/user-management/user-management.reducer';

import { Title } from 'app/shared/model/enumerations/title.model';
import { Nationality } from 'app/shared/model/enumerations/nationality.model';
import { District } from 'app/shared/model/enumerations/district.model';
import { City } from 'app/shared/model/enumerations/city.model';
import { Province } from 'app/shared/model/enumerations/province.model';
import { ResidencePurpose } from 'app/shared/model/enumerations/residence-purpose.model';

import { createEntity, getEntity, reset, updateEntity } from './foreigner-residence.reducer';

export const ForeignerResidenceUpdate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const users = useAppSelector(state => state.userManagement.users);
  const foreignerResidenceEntity = useAppSelector(state => state.foreignerResidence.entity);
  const loading = useAppSelector(state => state.foreignerResidence.loading);
  const updating = useAppSelector(state => state.foreignerResidence.updating);
  const updateSuccess = useAppSelector(state => state.foreignerResidence.updateSuccess);

  const titleValues = Object.keys(Title);
  const nationalityValues = Object.keys(Nationality);
  const districtValues = Object.keys(District);
  const cityValues = Object.keys(City);
  const provinceValues = Object.keys(Province);
  const residencePurposeValues = Object.keys(ResidencePurpose);

  /** ⭐ state สำคัญ แก้ปัญหา purpose เด้ง */
  const [purpose, setPurpose] = useState<string>('DRIVER_LICENSE');

  const handleClose = () => {
    navigate('/foreigner-residence');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
    dispatch(getUsers({}));
  }, []);

  useEffect(() => {
    if (!isNew && foreignerResidenceEntity?.purpose) {
      setPurpose(foreignerResidenceEntity.purpose);
    }
  }, [foreignerResidenceEntity]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const defaultValues = () =>
    isNew
      ? {
          foreignerTitle: 'MR',
          nationality: 'AFG',
          district: 'KOH_PHANGAN',
          city: 'PHANGAN',
          province: 'SURAT_THANI',
          purpose: 'DRIVER_LICENSE',
        }
      : {
          ...foreignerResidenceEntity,
          officer: foreignerResidenceEntity?.officer?.id,
        };

  const saveEntity = values => {
    if (values.id && typeof values.id !== 'number') values.id = Number(values.id);
    if (values.moo && typeof values.moo !== 'number') values.moo = Number(values.moo);

    if (values.purpose !== 'OTHER') {
      values.purposeOther = null;
    }

    const entity = {
      ...foreignerResidenceEntity,
      ...values,
      officer: users.find(u => u.id.toString() === values.officer?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2>
            <Translate contentKey="foreignerResidenceApp.foreignerResidence.home.createOrEditLabel" />
          </h2>
        </Col>
      </Row>

      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew && <ValidatedField name="id" readOnly required label={translate('global.field.id')} />}
              <ValidatedField
                name="recordNumber"
                label={translate('foreignerResidenceApp.foreignerResidence.recordNumber')}
                validate={{ required: { value: true, message: translate('entity.validation.required') } }}
              />
              <ValidatedField name="createDate" type="date" label={translate('foreignerResidenceApp.foreignerResidence.createDate')} />
              <ValidatedField name="recordDate" type="date" label={translate('foreignerResidenceApp.foreignerResidence.recordDate')} />
              <ValidatedField
                name="foreignerTitle"
                type="select"
                label={translate('foreignerResidenceApp.foreignerResidence.foreignerTitle')}
              >
                {titleValues.map(v => (
                  <option key={v} value={v}>
                    {translate(`foreignerResidenceApp.Title.${v}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                name="foreignerFullName"
                label={translate('foreignerResidenceApp.foreignerResidence.foreignerFullName')}
                validate={{ required: { value: true, message: translate('entity.validation.required') } }}
              />
              <ValidatedField name="nationality" type="select" label={translate('foreignerResidenceApp.foreignerResidence.nationality')}>
                {nationalityValues.map(v => (
                  <option key={v} value={v}>
                    {translate(`foreignerResidenceApp.Nationality.${v}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                name="foreignerPassportNo"
                label={translate('foreignerResidenceApp.foreignerResidence.foreignerPassportNo')}
                validate={{ required: { value: true, message: translate('entity.validation.required') } }}
              />
              <ValidatedField name="houseNo" label={translate('foreignerResidenceApp.foreignerResidence.houseNo')} />
              <ValidatedField name="moo" label={translate('foreignerResidenceApp.foreignerResidence.moo')} />
              <ValidatedField name="district" type="select" label={translate('foreignerResidenceApp.foreignerResidence.district')}>
                {districtValues.map(v => (
                  <option key={v} value={v}>
                    {translate(`foreignerResidenceApp.District.${v}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField name="city" type="select" label={translate('foreignerResidenceApp.foreignerResidence.city')}>
                {cityValues.map(v => (
                  <option key={v} value={v}>
                    {translate(`foreignerResidenceApp.City.${v}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField name="province" type="select" label={translate('foreignerResidenceApp.foreignerResidence.province')}>
                {provinceValues.map(v => (
                  <option key={v} value={v}>
                    {translate(`foreignerResidenceApp.Province.${v}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                name="purpose"
                type="select"
                label={translate('foreignerResidenceApp.foreignerResidence.purpose')}
                value={purpose}
                onChange={e => setPurpose(e.target.value)}
                validate={{ required: { value: true, message: translate('entity.validation.required') } }}
              >
                <option value="" />
                {residencePurposeValues.map(v => (
                  <option key={v} value={v}>
                    {translate(`foreignerResidenceApp.ResidencePurpose.${v}`)}
                  </option>
                ))}
              </ValidatedField>
              {purpose === 'OTHER' && (
                <ValidatedField
                  name="purposeOther"
                  label={translate('foreignerResidenceApp.foreignerResidence.purposeOther')}
                  validate={{ required: { value: true, message: translate('entity.validation.required') } }}
                />
              )}
              <ValidatedField
                name="condition37"
                check
                type="checkbox"
                label={translate('foreignerResidenceApp.foreignerResidence.condition37')}
              />
              <ValidatedField
                name="condition38"
                check
                type="checkbox"
                label={translate('foreignerResidenceApp.foreignerResidence.condition38')}
              />
              <ValidatedField name="officer" type="select" label={translate('foreignerResidenceApp.foreignerResidence.officer')}>
                <option value="" />
                {users
                  ?.filter(u => u.login !== 'admin')
                  .map(u => (
                    <option key={u.id} value={u.id}>
                      {`${u.firstName ?? ''} ${u.lastName ?? ''}`.trim()}
                    </option>
                  ))}
              </ValidatedField>
              <Button tag={Link} to="/foreigner-residence" replace color="info">
                <Translate contentKey="entity.action.back" />
              </Button>
              &nbsp;
              <Button color="primary" type="submit" disabled={updating}>
                <Translate contentKey="entity.action.save" />
              </Button>
              &nbsp;
              {!isNew && (
                <Button color="warning" onClick={() => (window.location.href = `/foreigner-residence/${id}/print`)}>
                  <FontAwesomeIcon icon={faPrint} /> <Translate contentKey="entity.action.print" />
                </Button>
              )}
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ForeignerResidenceUpdate;
